import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../src/hooks/storeHooks';
import SearchIcon from '../../../images/search-icon.svg';
import { setFilterTerm } from '../supportSlice';

interface Tab {
  label: string;
  component: React.ComponentType<any>;
}

interface TabsProps {
  tabs: Tab[];
  assetDetails?: boolean;
  groupName?: string;
}

const AssetsTabsSupport: React.FC<TabsProps> = ({ tabs, assetDetails = false, groupName }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const dispatch = useAppDispatch();
  const filterTerm = useAppSelector((state) => state?.SupportSlice?.filterTerm);


  const handleFilterTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterTerm(e.target.value));
  };

  const renderSearchInput = () => {
    return (
      <div
        className='input-group'
        style={{ width: '325px', marginRight: '24px', marginTop: (tabs[activeTabIndex].label === 'List' || tabs[activeTabIndex].label === 'Alarms') ? '1rem' : '0' }}
      >
        <div className='icon-block'>
          <img src={SearchIcon} alt='Search Icon' style={{ pointerEvents: 'visible', cursor: 'pointer' }} />
        </div>
        <input
          className='custom-input search'
          placeholder='Search'
          value={filterTerm}
          onChange={handleFilterTermChange}
          style={{ padding: '10px 14px 10px 32px' }}
        />
      </div>
    );
  };

  const renderAdditionalBlocks = () => {
    if (tabs[activeTabIndex].label === 'List' || tabs[activeTabIndex].label === 'Alarms') {
      return renderSearchInput();
    } else {
      return (
        <>
          <div className='input-group' style={{ width: '325px', marginRight: '10px', marginTop: '10px' }}>
            <div className='icon-block'>
              <img src={SearchIcon} alt='Search Icon' />
            </div>
            {renderSearchInput()}
          </div>
        </>
      );
    }
  };

  return (
    <>
      <div className={`wrapper-location ${assetDetails && 'asset-details'}`}>
        <div className='ui-button-toolbar'>
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`ui-button-toolbar-button ${index === activeTabIndex ? 'ui-button-toolbar-button-active' : ''
                }`}
              onClick={() => setActiveTabIndex(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className='show-alram-traffic'>
          {!assetDetails && renderAdditionalBlocks()}
        </div>
      </div>
      <div className='tab-content'>
        {tabs.map((tab, index) => {
          return (
            <div key={index} style={{ display: index === activeTabIndex ? 'block' : 'none' }}>
              {React.createElement(tab?.component, { groupName, } as React.Attributes)}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AssetsTabsSupport;
